import { LANG } from 'utils/constants';
import { RefData } from 'types/interfaces';
import { KycQuestion } from './types';

const extractCode = (rawValue: unknown): string | undefined => {
  if (typeof rawValue === 'string') return rawValue;
  if (rawValue != null && typeof rawValue === 'object' && !Array.isArray(rawValue)) {
    return (rawValue as { code?: string }).code;
  }
  return undefined;
};

export const resolveKycTitle = (question: KycQuestion | undefined, locale: string, fallbackTitle: string): string => {
  if (!question) return fallbackTitle;
  return locale === LANG.FR ? question.questionFrDescription : question.questionEnDescription;
};

export const resolveKycRefData = (question: KycQuestion | undefined): RefData[] | undefined => {
  if (!question?.possibleAnswers?.length) return undefined;
  return question.possibleAnswers.map((answer) => ({
    valueDomainCode: answer.answerCode,
    fr: { label: answer.answerFrDescription },
    en: { label: answer.answerEnDescription },
  }));
};

export const resolveRefDataLabel = (
  rawValue: unknown,
  refData: RefData[] | undefined,
  locale: string,
): string | undefined => {
  if (!refData) return undefined;
  const code = extractCode(rawValue);
  if (!code) return undefined;
  const match = refData.find((item) => item.valueDomainCode === code);
  return match?.[locale as 'en' | 'fr']?.label;
};
